import { useState, useCallback } from 'react';
import Toast from 'react-native-root-toast';
import { Color } from '../styles';
import { LOST_RECEIPT_OPTION } from '../constants/Enums';

const MAX_RECEIPTS_COUNT = 5;

export const useReceiptSelection = (initialImages = []) => {
  const [selectedImages, setSelectedImages] = useState(initialImages);

  const toggleSelectImage = useCallback(
    (selectedReceipt) =>
      setSelectedImages((prevSelected) => {
        if (prevSelected.some(({ receiptId }) => receiptId === selectedReceipt.receiptId)) {
          return prevSelected.filter(({ receiptId }) => receiptId !== selectedReceipt.receiptId);
        }
        // in case no receipt was selected it will be removed from the selected images
        if (prevSelected.length === 1 && prevSelected[0].id === LOST_RECEIPT_OPTION.id) {
          return [selectedReceipt];
        }

        if (prevSelected.length < MAX_RECEIPTS_COUNT) {
          return [...prevSelected, selectedReceipt];
        }

        Toast.show(`You can only select up to ${MAX_RECEIPTS_COUNT} receipts.`, {
          duration: Toast.durations.SHORT,
          position: Toast.positions.BOTTOM,
          shadow: true,
          animation: true,
          hideOnPress: true,
          backgroundColor: Color.gray,
          textColor: Color.accent,
        });

        return prevSelected;
      }),
    []
  );

  return {
    selectedImages,
    setSelectedImages,
    toggleSelectImage,
  };
};
